var a = /* @__PURE__ */ ((e) => (e.fill = "fill", e.outline = "outline", e))(a || {});
function i(e) {
  const t = ["touch-area", "touch-area-switch"];
  return e.variant === "outline" && t.push("touch-area-outline"), e.error && t.push("touch-area-invalid"), e.disabled && t.push("touch-area-disabled"), e.labelFirst && t.push("touch-area-switch-revert"), t.join(" ");
}
export {
  a as ESwitchBorderVariants,
  i as getSwitchBorderStyleClasses
};
